import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import type { CriterioEvaluacion, ObjetivoGenerico } from "../types";
import StatusLine from "./StatusLine"
import ObjetivoGenericoItem from "./ObjetivoGenericoItem";

interface Props {
  aeId: string;
  ce: CriterioEvaluacion;

  expanded: boolean;
  onToggle: (next: boolean) => void;
  onFetchOG: () => Promise<void>;

  ogs: ObjetivoGenerico[];
  loadingOG: boolean;
  errorOG: string;

  isOGSelected: (aeId: string, ceId: string, ogId: string) => boolean;
  toggleOGSelection: (aeId: string, ceId: string, ogId: string) => void;
}

const CriterioAccordion: React.FC<Props> = ({
  aeId,
  ce,
  expanded,
  onToggle,
  onFetchOG,
  ogs,
  loadingOG,
  errorOG,
  isOGSelected,
  toggleOGSelection,
}) => {
  const hasOgs = ogs.length > 0;
  const showEmpty = !loadingOG && !errorOG && !hasOgs;

  return (
    <Accordion
      expanded={expanded}
      onChange={async (_e, next) => {
        onToggle(next);
        if (next) await onFetchOG();
      }}
      disableGutters
      sx={{
        border: "0.5px solid rgba(0,0,0,0.08)",
        borderRadius: "10px",
        overflow: "hidden",
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "0.8rem",
            fontWeight: 400,
            color: "rgba(0,0,0,0.75)",
            lineHeight: 1.25,
          }}
        >
          {ce.texto}
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ pt: 0.5 }}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "0.78rem",
            fontWeight: 700,
            color: "rgba(0,0,0,0.60)",
            mb: 0.8,
            ml: 1,
          }}
        >
          OBJETIVOS GENÉRICOS
        </Typography>

        <StatusLine
          size="sm"
          loading={loadingOG}
          loadingText="Cargando objetivos genéricos..."
          error={errorOG}
          empty={showEmpty}
          emptyText="No se encontraron objetivos genéricos para este criterio."
        />

        {!loadingOG && !errorOG && hasOgs && (
          <Stack spacing={0.5}>
            {ogs.map((og) => {
              const checked = isOGSelected(aeId, ce.id, og.id);
              return (
                <ObjetivoGenericoItem
                  key={og.id}
                  og={og}
                  checked={checked}
                  onToggle={() => toggleOGSelection(aeId, ce.id, og.id)}
                />
              );
            })}
          </Stack>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default CriterioAccordion;
